import className from 'classnames/bind';
import {useEffect} from "react";
import {Link, useLocation} from "react-router-dom";
import {FontAwesomeIcon} from "~/components";
import {LEGAL} from "~/features/Legal/legalConfig";
import style from '../style/Legal.module.scss';

const cn = className.bind(style);

const home = process.env.REACT_APP_HOMEPAGE || '';

/**
 * Khung dùng chung cho các trang pháp lý CÔNG KHAI (Privacy Policy / Điều khoản).
 * Google OAuth verification yêu cầu các trang này truy cập được không cần đăng nhập
 * trên domain đã verify — vì vậy layout tự chứa header/footer, không dùng DefaultLayout.
 */
function LegalLayout({title, children}) {

	const {pathname} = useLocation();

	useEffect(() => {
		document.title = `${title} - ${LEGAL.appName}`;
		window.scrollTo(0, 0);
		return () => { document.title = LEGAL.appName; };
	}, [title]);

	const isActive = (path) => pathname === `${home}${path}` || pathname === path;

	return (
		<div className={cn('legal-page')}>
			<header className={cn('legal-header')}>
				<Link to={`${home}/`} className={cn('brand')}>
					<span className={cn('brand-badge')}><FontAwesomeIcon icon="fa-light fa-chart-line"/></span>
					<span className={cn('brand-name')}>{LEGAL.appName}</span>
				</Link>
				<nav className={cn('header-links')}>
					<Link to={`${home}/privacy-policy`} className={cn({active: isActive('/privacy-policy')})}>
						Chính sách bảo mật
					</Link>
					<Link to={`${home}/terms`} className={cn({active: isActive('/terms')})}>
						Điều khoản sử dụng
					</Link>
					<Link to={`${home}/login`} className={cn('login-link')}>Đăng nhập</Link>
				</nav>
			</header>

			<div className={cn('legal-body')}>
				<div className={cn('legal-card')}>
					<div className={cn('legal-title')}>
						<h1>{title}</h1>
						<div className={cn('effective')}>Có hiệu lực từ: {LEGAL.effectiveDate}</div>
					</div>
					<div className={cn('legal-content')}>
						{children}
					</div>
				</div>

				<div className={cn('legal-footer')}>
					© {new Date().getFullYear()} {LEGAL.appName}. Bảo lưu mọi quyền.
					<span className={cn('sep')}>·</span>
					<Link to={`${home}/privacy-policy`}>Chính sách bảo mật</Link>
					<span className={cn('sep')}>·</span>
					<Link to={`${home}/terms`}>Điều khoản sử dụng</Link>
					<span className={cn('sep')}>·</span>
					<a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>
				</div>
			</div>
		</div>
	);
}

export default LegalLayout;
